import React, { useState, useEffect } from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Container } from 'react-bootstrap';

import { httpPost } from '../services/http';
import { t } from '../services/storage';

import { addToCart, removeFromCart } from '../db/Cart';

const DEFAULT_STATE = {
  history: [],
  name: '',
  username: '',
  phone: '',
  password: '',
  password2: '',
};

const Cabinet = (props) => {
  const { user } = props;
  const [state, setState] = useState(DEFAULT_STATE);

  useEffect(() => {
    httpPost('order/getAll', { userId: (user || {})._id }).then((res) => {
      setState({ history: res.data });
    });
  }, []);

  return (
    <>
      <Container style={{ minHeight: 700 }}>
        <h3 style={{ fontWeight: 'bold' }}>Личный кабинет</h3>
        {!!state.history.length ? (
          <table className='cart' style={{ width: '100%', marginTop: 20 }}>
            <thead>
              <tr>
                <th>Дата</th>
                <th>Товары</th>
                <th>Цена</th>
                <th>Количество</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              {state.history.map(({ _id, items, date }) => {
                let Items = '';
                let Prices = '';
                let Counts = '';
                let summ = 0;

                items.forEach(({ name, price, count }) => {
                  summ += parseFloat(price);
                  Items += `<div>${name}</div>`;
                  Prices += `<div>${parseFloat(price).toFixed(0)} PLN</div>`;
                  Counts += `<div>${count}</div>`;
                });

                return (
                  <tr key={_id} style={{ padding: '20px 0' }}>
                    <td>{new Date(date).toLocaleDateString()}</td>
                    <td dangerouslySetInnerHTML={{ __html: Items }} />
                    <td dangerouslySetInnerHTML={{ __html: Prices }} />
                    <td dangerouslySetInnerHTML={{ __html: Counts }} />
                    <td>{summ.toFixed(0)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <span className='noEntry'>Нет Покупок</span>
        )}
      </Container>
    </>
  );
};

function mapStateToProps(state) {
  return {
    view: state.view,
    translate: state.translate,
    cart: state.cart,
    user: state.user,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators({ t, addToCart, removeFromCart }, dispatch);
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Cabinet));
